import React from 'react';
import { ArrowRight } from 'lucide-react';

const WHATSAPP_DRIVER_GROUP = 'https://chat.whatsapp.com/DTkQ9fP3Z8vA5SRewERWk0';

/** Driver announcement WhatsApp group CTA. */
export const DriverWhatsAppGroup = () => (
  <a
    href={WHATSAPP_DRIVER_GROUP}
    target="_blank"
    rel="noopener noreferrer"
    className="group block mb-6 rounded-xl border border-[#25D366]/30 bg-gradient-to-r from-[#E8FDF1] via-white to-[#E8FDF1] hover:shadow-lg hover:shadow-green-100 transition-all p-4 sm:p-5"
    data-testid="driver-whatsapp-group-cta"
  >
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
      <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#25D366] flex items-center justify-center shadow-md shadow-green-200">
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.926 15.926 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.35 22.616c-.396 1.116-1.96 2.042-3.21 2.312-.856.182-1.974.326-5.736-1.232-4.814-1.994-7.908-6.882-8.148-7.204-.232-.322-1.94-2.586-1.94-4.932s1.228-3.498 1.664-3.978c.436-.48.952-.6 1.268-.6.316 0 .632.002.908.016.292.016.682-.11 1.068.814.396.952 1.348 3.298 1.468 3.538.118.24.196.52.038.838-.158.322-.238.52-.476.802-.238.282-.5.63-.714.846-.238.238-.486.496-.208.974.278.476 1.234 2.034 2.65 3.296 1.82 1.622 3.354 2.124 3.83 2.362.476.238.754.198 1.032-.12.278-.316 1.19-1.386 1.508-1.862.316-.476.634-.396 1.07-.238.436.158 2.78 1.312 3.256 1.55.476.238.794.356.912.556.118.198.118 1.152-.278 2.268z" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-[#25D366]/15 text-[#0e7a3c] text-[11px] font-bold uppercase tracking-wide">
            New
          </span>
          <h3 className="text-lg sm:text-xl font-bold text-[#050505] leading-tight tracking-tight">
            Join our driver announcement group
          </h3>
        </div>
        <p className="mt-1 text-sm text-[#4B5563]">
          Get updates, tips &amp; tricks first. <span className="font-semibold text-[#1B5E20]">Mute anytime.</span>
        </p>
      </div>
      <div
        className="flex-shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-[#25D366] text-white font-bold text-sm hover:bg-[#1DA851] transition-colors active:scale-95 w-full sm:w-auto"
        data-testid="driver-whatsapp-join-btn"
      >
        Join the group
        <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
      </div>
    </div>
  </a>
);

export default DriverWhatsAppGroup;
